import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import {
    DealerFeature,
    FootnotesPipe,
    HomeFeature,
    LoginFeature,
    RouterLinkDirective,
    TrackingDirective,
} from '@hyundai/ng-common-lib';
import { EditableDirective } from '@hyundai/ng-edit-lib';
import {
    M000C010ImageComponent,
    M010C020IconLinkComponent,
    M040C040PromotionBannerComponent,
    M040C050CardComponent,
    M040C060CardSmallComponent,
} from '@hyundai/ui';
import { QuickSearchComponent } from '@hyundai/vehicle-market-lib';
import { Store } from '@ngrx/store';
import {
    NgxPxCarouselAwesomePlusComponent,
    NgxPxCarouselAwesomePlusItemDirective,
} from '@pixelgenau/ngx-carousel-awesome-plus';
import { GlobalContactComponent } from '../../components/global-contact/global-contact.component';
import { ABOUT_US_TABS } from '../about-us-page/about-us-infos';
import { HomeButtonsComponent } from './components/home-buttons/home-buttons.component';
import { PromotionLinkComponent } from './components/promotion-link/promotion-link.component';
import { HomePageModelsComponent } from './sections/home-page-models/home-page-models.component';

@Component({
    selector: 'app-home-page',
    standalone: true,
    templateUrl: './home-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'app-home-page',
    },
    styleUrls: ['./home-page.component.scss'],
    imports: [
        RouterLinkDirective,
        HomePageModelsComponent,
        PromotionLinkComponent,
        NgxPxCarouselAwesomePlusComponent,
        NgxPxCarouselAwesomePlusItemDirective,
        M000C010ImageComponent,
        M010C020IconLinkComponent,
        GlobalContactComponent,
        M040C040PromotionBannerComponent,
        M040C050CardComponent,
        FootnotesPipe,
        EditableDirective,
        TrackingDirective,
        M040C060CardSmallComponent,
        HomeButtonsComponent,
        QuickSearchComponent,
        NgClass,
    ],
})
export default class HomePageComponent {
    aboutUsJobsFragment = ABOUT_US_TABS.JOBS;

    store = inject(Store);

    home = this.store.selectSignal(HomeFeature.state.selectLoadedHome);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    dealerContactMailLink = this.store.selectSignal(DealerFeature.state.selectDealerContactFormUrl);
    dealerServiceMailLink = this.store.selectSignal(DealerFeature.state.selectDealerServiceFormUrl);
    dealerLocationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
    homeCampaigns = this.store.selectSignal(HomeFeature.state.selectHomeCampaigns);
    keyCampaign = this.store.selectSignal(DealerFeature.state.selectKeyCampaign);
    hcmTeaser = this.store.selectSignal(HomeFeature.state.selectHcmTeaser);
    homeImageTextContent = this.store.selectSignal(HomeFeature.state.selectHomeImageTextContent);
    homeTeasers = this.store.selectSignal(HomeFeature.state.selectHomeTeasers);
    homeContactEmployee = this.store.selectSignal(HomeFeature.state.selectHomeContactEmployee);
    isLogedIn = this.store.selectSignal(LoginFeature.state.selectIsLoggedIn);

    dealerServiceOnly = computed(() => this.dealer().dealerType === 'Service');
    dealerSalesOnly = computed(() => this.dealer().dealerType === 'Sales');

    homeCampaignsSliced = computed(() => {
        const cards = this.homeCampaigns();
        return cards.slice(0, 4);
    });
}
